const frontSideColorSelected = (value: string): boolean => {
  return value !== "none";
};

export default frontSideColorSelected;
